<mat-toolbar color="primary">
    <h5>{{'CUSTOMER_MERGED' | translate}}</h5>
</mat-toolbar>
<div class="mdc-p-3 ">
    <p class="mat-text-secondary">{{'DUPLICATE_CUSTOMER_MERGED' | translate}}</p>
    <button mat-raised-button (click)="redirect()" color="accent">{{'VIEW_MERGED_PROFILE' | translate}}</button>
</div>
